const CALLBOT_API_URL = process.env.CALLBOT_API_URL || "http://localhost:8000/bot-app";

export async function fetchState(callId) {
  return await fetch(`${CALLBOT_API_URL}/state/${callId}`);
}
